<template>
  <camoodoo-page icon="help_outline" title="Help">
    <simple-section dark title="Connecting...">
      <page-link label="Canon camera" route="/help/connectCanon" />
      <page-link label="Sony camera" route="/help/connectSony" />
      <page-link
        label="Sony camera with Playmemories support"
        route="/help/connectSonyPlaymemories"
      />
    </simple-section>
    <simple-section light title="Others">
      <page-link label="FAQ" route="/faq" />
      <page-link label="Compatibility" route="/compatibility" />
    </simple-section>
  </camoodoo-page>
</template>

<script>
import CamoodooPage from "@/components/CamoodooPage.vue";
import SimpleSection from "../sections/SimpleSection.vue";
import PageLink from "../components/PageLink.vue";

export default {
  components: {
    CamoodooPage,
    SimpleSection,
    PageLink,
  },

  methods: {
    onPage(page) {
      this.$router.push(page);
    },
  },
};
</script>

<style lang="scss" scoped></style>
